import React from 'react';
import { Button, mq } from '@kvdbil/components';
import styled from 'styled-components';
import { scroller } from 'react-scroll';
import { useSelector } from 'react-redux';
import { AnchorNavigationRecord } from '~/config/generated/graphql';
import { slugify } from '~/helpers/slugify';
import { headerHeightSelector } from '~/App/shared/selectors/header';
import { useIsDevice } from '~/App/shared/hooks/useIsDevice';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 1rem;

  ${mq('mobileL')} {
    flex-direction: row;
  }
`;

interface Props {
  items: AnchorNavigationRecord['items'];
}

const AnchorNavigation = ({ items }: Props) => {
  const headerHeight = useSelector(headerHeightSelector) ?? 0;
  const { isMobile } = useIsDevice();

  const handleClick = (sectionHeading: string) => {
    scroller.scrollTo(slugify(sectionHeading), {
      duration: 400,
      smooth: true,
      dynamic: true,
      offset: ((isMobile ? 0 : headerHeight) + 32) * -1
    });
  };

  return (
    <Container>
      {items.map(item => {
        if (!item.sectionHeading) return null;

        return (
          <Button
            key={item.id}
            color="info"
            colorShade="dark"
            variant="outline"
            onClick={() => handleClick(item.sectionHeading as string)}
          >
            {item.sectionHeading}
          </Button>
        );
      })}
    </Container>
  );
};

export default AnchorNavigation;
